export default class CustomerData {
  constructor({ mobile, name, address }) {
    this.mobile = mobile || '';
    this.name = name || '';
    this.address = address || '';
  }
}
